import { render } from "./IconImportant.vue?vue&type=template&id=14ae8d24"
import script from "./IconImportant.vue?vue&type=script&lang=js"
export * from "./IconImportant.vue?vue&type=script&lang=js"
script.render = render

export default script